import React from 'react';
import { NavLink } from 'react-router-dom';

import VisitInfo from './info';
import VisitRecipes from './visitRecipes';
import BuyRecipes from '../../common/buyRecipes';

export default function Visit({ visit, user }) {
  return (
    <li className="personal-visits-list__item visit-detail" key={visit.id}>
      <NavLink to="/office/visits" className="visit-detail__back-link">
        <i className="fas fa-chevron-left" />
        До списку візитів
      </NavLink>

      <VisitInfo {...visit} user={user} />

      {visit.promo_text && (
        <div className="visit-by-code-page__pharm-text">
          <div className="visit-by-code-page__pharm-text-icon">
            <i className="fas fa-pills" />
          </div>
          <p className="visit-by-code-page__pharm-text-body" dangerouslySetInnerHTML={{ __html: visit.promo_text }} />
        </div>
      )}
      
      <VisitRecipes {...visit} />

      <BuyRecipes buUrl={visit.buy_url} />
    </li>
  );
}
